import React, { useState } from "react";
import "../../styles/wobbleCard.css";

const WobbleCard = ({ children, containerClassName = "", className = "" }) => {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [isHovering, setIsHovering] = useState(false);

  const handleMouseMove = (event) => {
    const rect = event.currentTarget.getBoundingClientRect();
    const x = (event.clientX - (rect.left + rect.width / 2)) / 20;
    const y = (event.clientY - (rect.top + rect.height / 2)) / 20;
    setMousePosition({ x, y });
  };

  return (
    <section
      className={`wobble-card ${containerClassName}`}
      onMouseMove={handleMouseMove}
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => {
        setIsHovering(false);
        setMousePosition({ x: 0, y: 0 });
      }}
      style={{
        transform: isHovering
          ? `translate3d(${mousePosition.x}px, ${mousePosition.y}px, 0)`
          : "translate3d(0, 0, 0)",
      }}
    >
      <div className="wobble-inner">
        <div
          className={`wobble-content ${className}`}
          style={{
            transform: isHovering
              ? `translate3d(${-mousePosition.x}px, ${-mousePosition.y}px, 0) scale3d(1.03, 1.03, 1)`
              : "translate3d(0, 0, 0) scale3d(1, 1, 1)",
          }}
        >
          <div className="noise-layer"></div>
          {children}
        </div>
      </div>
    </section>
  );
};

export default WobbleCard;
